import React from 'react';
import { RouteComponentProps, withRouter } from 'react-router';
import { isMobileOnly } from 'react-device-detect';
import styled, { css } from 'styled-components';
import { FlexBox } from '@docon/docon-ui-library';
import Image from 'shared/Image';
import { colors } from 'utilities/colorConfig';

const doconLogo = '/images/docon.svg';
const logout = '/images/logout.svg';
const help = '/images/help.svg';

const Root = styled(FlexBox)`
  height: 56px;
  width: 100%;
  align-items: center;
  gap: 12px;
  flex: 0 0 auto;
  padding: 0 30px;
  background-color: ${colors.white};
  box-shadow: 0 2px 4px 0 ${colors.boxShadow};
  z-index: 1;

  ${Image} {
    height: 24px;

    &:not(&:first-child) {
      cursor: pointer;
    }
  }

  ${() => isMobileOnly && css`
    padding: 0 16px;
  `}
`;

export type IProps = RouteComponentProps;

function DoconHeader({ history }: IProps) {

  function handleClick(event: any) {
    const id = event?.currentTarget?.id;
    if (id) history.push(`/${id}`);
  }

  return (
    <Root>
      <Image src={doconLogo} alt='doconLogo' />
      <Image
        id='support/help'
        ml='auto'
        src={help}
        alt='help'
        onClick={handleClick}
      />
      <Image
        id='logout'
        alt='logout'
        src={logout}
        onClick={handleClick}
      />
    </Root>
  );
}

export default withRouter(DoconHeader);
